"use strict";

function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireWildcard(require("react"));
var _reactI18next = require("react-i18next");
var _classnames = _interopRequireDefault(require("classnames"));
var _reduxForm = require("redux-form");
var _cssClassesHelper = require("../../../../helpers/cssClassesHelper");
var _modalActions = require("../../../../redux/actions/modalActions");
var _Modal = _interopRequireDefault(require("../../../common/Modal/Modal"));
var _modalDecorator = _interopRequireDefault(require("../../../../hocs/modalDecorator"));
var _FormItem = require("../../../form/FormItem");
var _NumberInput = require("../../../form/NumberInput");
var _useCalculatorPnLValue = require("./useCalculatorPnLValue");
var _formValidations = require("../../../../helpers/formValidations");
var _numberFormatter = require("../../../../helpers/numberFormatter");
var _APSegmentedButton = _interopRequireDefault(require("../../../common/APSegmentedButton"));
require("./FuturesPnLCalculatorModal.css");
function _interopRequireDefault(e) { return e && e.__esModule ? e : { "default": e }; }
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != _typeof(e) && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); return f; })(e, t); }
var form = 'PnLCalculator';
var bemCalculatorClasses = (0, _cssClassesHelper.getBEMClasses)('futures-pnl-calculator');
var bemPnLClasses = (0, _cssClassesHelper.getBEMClasses)('pnl');
var FuturesPnLCalculatorModal = function FuturesPnLCalculatorModal(_ref) {
  var _selectedInstrument$P, _selectedInstrument$P2;
  var isOpen = _ref.isOpen,
    close = _ref.close,
    reset = _ref.reset;
  var _useTranslation = (0, _reactI18next.useTranslation)('order'),
    t = _useTranslation.t;
  var _useCalculatorPnLValu = (0, _useCalculatorPnLValue.useCalculatorPnLValue)(form),
    selectedInstrument = _useCalculatorPnLValu.selectedInstrument,
    valueDP = _useCalculatorPnLValu.valueDP,
    quantityDP = _useCalculatorPnLValu.quantityDP,
    PnLValue = _useCalculatorPnLValu.PnLValue,
    PnLCurrency = _useCalculatorPnLValu.PnLCurrency,
    contractCurrency = _useCalculatorPnLValu.contractCurrency,
    maxPosition = _useCalculatorPnLValu.maxPosition,
    maxAmount = _useCalculatorPnLValu.maxAmount;
  var maxLeverageValidator = (0, _react.useCallback)(function (value) {
    return value && selectedInstrument !== null && selectedInstrument !== void 0 && selectedInstrument.MaximumLeverage && value > (selectedInstrument === null || selectedInstrument === void 0 ? void 0 : selectedInstrument.MaximumLeverage) ? "Must be less than ".concat(selectedInstrument === null || selectedInstrument === void 0 ? void 0 : selectedInstrument.MaximumLeverage) : undefined;
  }, [selectedInstrument === null || selectedInstrument === void 0 ? void 0 : selectedInstrument.MaximumLeverage]);
  var maxAmountValidator = (0, _react.useCallback)(function (value) {
    return value && maxAmount !== null && maxAmount !== void 0 && maxAmount.value && value > (maxAmount === null || maxAmount === void 0 ? void 0 : maxAmount.value) ? "Must be less than ".concat(maxAmount === null || maxAmount === void 0 ? void 0 : maxAmount.value) : undefined;
  }, [maxAmount === null || maxAmount === void 0 ? void 0 : maxAmount.value]);
  var handlePnLCalculatorModalClose = (0, _react.useCallback)(function () {
    close();
    reset();
  }, [close, reset]);
  return /*#__PURE__*/_react["default"].createElement(_Modal["default"], {
    isOpen: isOpen,
    close: handlePnLCalculatorModalClose,
    customClass: bemCalculatorClasses('modal'),
    title: "".concat(selectedInstrument === null || selectedInstrument === void 0 ? void 0 : selectedInstrument.Symbol, " Calculator")
  }, /*#__PURE__*/_react["default"].createElement("form", {
    className: bemCalculatorClasses('form')
  }, /*#__PURE__*/_react["default"].createElement(_reduxForm.Field, {
    name: "type",
    component: function component(_ref2) {
      var _input$value;
      var input = _ref2.input;
      return /*#__PURE__*/_react["default"].createElement(_APSegmentedButton["default"], {
        name: input.name,
        items: [{
          value: 'Long',
          text: t('Long'),
          dataTest: 'Long Type',
          onClick: function onClick() {
            return input.onChange('Long');
          }
        }, {
          value: 'Short',
          text: t('Short'),
          dataTest: 'Short Type',
          onClick: function onClick() {
            return input.onChange('Short');
          }
        }],
        customClass: bemCalculatorClasses(),
        styleName: (_input$value = input.value) === null || _input$value === void 0 ? void 0 : _input$value.toLowerCase()
      });
    }
  }), /*#__PURE__*/_react["default"].createElement(_FormItem.RFormInputItem, {
    size: "small",
    component: _NumberInput.MoneyInput,
    name: "leverage",
    label: t('Leverage'),
    symbol: 'X',
    infoText: maxPosition !== null && maxPosition !== void 0 && maxPosition.value ? /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
      ns: "order",
      i18nKey: "PnL Max Position"
    }, "Max Position:", ' ', /*#__PURE__*/_react["default"].createElement("b", null, {
      value: (0, _numberFormatter.formatNumberToLocale)(maxPosition.value, maxPosition.symbol)
    }, ' ', {
      symbol: maxPosition.symbol
    })) : undefined,
    validate: [_formValidations.required, _formValidations.greaterThanOrEqualToZero, maxLeverageValidator],
    decimalPlaces: 0
  }), /*#__PURE__*/_react["default"].createElement(_FormItem.RFormInputItem, {
    size: "small",
    component: _NumberInput.MoneyInput,
    name: "entryPrice",
    label: t('Entry Price'),
    symbol: (_selectedInstrument$P = selectedInstrument === null || selectedInstrument === void 0 ? void 0 : selectedInstrument.Product2Symbol) !== null && _selectedInstrument$P !== void 0 ? _selectedInstrument$P : '',
    validate: [_formValidations.required, _formValidations.greaterThanOrEqualToZero],
    decimalPlaces: valueDP
  }), /*#__PURE__*/_react["default"].createElement(_FormItem.RFormInputItem, {
    size: "small",
    component: _NumberInput.MoneyInput,
    name: "exitPrice",
    label: t('Exit Price'),
    symbol: (_selectedInstrument$P2 = selectedInstrument === null || selectedInstrument === void 0 ? void 0 : selectedInstrument.Product2Symbol) !== null && _selectedInstrument$P2 !== void 0 ? _selectedInstrument$P2 : '',
    validate: [_formValidations.required, _formValidations.greaterThanOrEqualToZero],
    decimalPlaces: valueDP
  }), /*#__PURE__*/_react["default"].createElement(_FormItem.RFormInputItem, {
    size: "small",
    component: _NumberInput.MoneyInput,
    name: "quantity",
    label: t('Amount'),
    infoText: maxAmount !== null && maxAmount !== void 0 && maxAmount.value ? /*#__PURE__*/_react["default"].createElement(_reactI18next.Trans, {
      i18nKey: "PnL Max Amount",
      ns: "order"
    }, "Max Amount:", ' ', /*#__PURE__*/_react["default"].createElement("b", null, {
      value: maxAmount.value
    }, " ", {
      symbol: maxAmount.symbol
    })) : undefined,
    symbol: contractCurrency,
    validate: [_formValidations.required, _formValidations.greaterThanOrEqualToZero, maxAmountValidator],
    decimalPlaces: quantityDP
  }), /*#__PURE__*/_react["default"].createElement("div", {
    className: (0, _classnames["default"])(bemCalculatorClasses('pnl'), bemPnLClasses())
  }, /*#__PURE__*/_react["default"].createElement("div", {
    className: bemPnLClasses('label')
  }, t('Profit / Loss')), /*#__PURE__*/_react["default"].createElement("div", {
    className: bemPnLClasses('value')
  }, (0, _numberFormatter.formatNumberToLocale)(PnLValue, PnLCurrency), " ", PnLCurrency))));
};
var wrapped = (0, _reduxForm.reduxForm)({
  form: form,
  initialValues: {
    type: 'Long',
    leverage: '',
    entryPrice: '',
    exitPrice: '',
    quantity: ''
  },
  onSubmit: function onSubmit() {}
})(FuturesPnLCalculatorModal);
var _default = exports["default"] = (0, _modalDecorator["default"])({
  name: _modalActions.MODAL_TYPES.FUTURES_PNL_CALCULATOR
})(wrapped);